import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"
import { RootState } from "./store"

// Tab constants
export const TAB_TYPES = {
  CHATS: "chats",
  SLICK_AI: "slickAI",
  TIMELINE: "timeline",
  CMR: "CMR",
  CAR_ISSUES: "carIssues",
  FLEET_OVERVIEW: "fleetOverview",
  PLAN_ORDER: "planOrder",
  REPORTS: "reports",
  DELIVERY_ORDERS: "deliveryOrders",
  DRIVER_MANAGEMENT: "driverManagement",
  CREW_BOARD: "crewBoard",
  DAILY_ROUTES: "dailyRoutes",
  STATS: "stats",
  FUEL_REPORT: "fuelReport",
  MY_CARS: "myCars",
  USER_MANAGEMENT: "userManagement",
  GPS_MANAGEMENT: "gpsManagement",
} as const

export type TabType =
  | "chats"
  | "slickAI"
  | "timeline"
  | "CMR"
  | "carIssues"
  | "fleetOverview"
  | "planOrder"
  | "reports"
  | "deliveryOrders"
  | "driverManagement"
  | "crewBoard"
  | "dailyRoutes"
  | "stats"
  | "fuelReport"
  | "myCars"
  | "userManagement"
  | "gpsManagement"

export type Tabs = {
  activeTab: TabType
  previousTab: TabType | null
  previousActiveChat: string | null
}

const initialState: Tabs = {
  activeTab: TAB_TYPES.CHATS,
  previousTab: null,
  previousActiveChat: null,
}

type ChangeActiveTabAction = {
  activeTab: TabType
}

type UpdateLastActiveChatAction = {
  previousActiveChat: string | null
}

export const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    changeActiveTab: (state, action: PayloadAction<ChangeActiveTabAction>) => {
      {
        state.previousTab = state.activeTab
        state.activeTab = action.payload.activeTab
      }
    },
    updateLastActiveChat: (
      state,
      action: PayloadAction<UpdateLastActiveChatAction>,
    ) => {
      {
        state.previousActiveChat = action.payload.previousActiveChat
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const selectTabs = (state: RootState) => {
  return state.tabs
}

export const { changeActiveTab, updateLastActiveChat } = tabsSlice.actions
export default tabsSlice.reducer
